import React from "react";
import ServiceHeader from "../../component/ServiceHeader";
import ContactUs from "../../component/contactus";
import "../../views/PageContent.css";
import Myimage from "../../assets/AI images/Healthcare.jpg";
import { useNavigate, useLocation } from "react-router-dom";

// Icon components using inline SVG


const MessageIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 48, height: 48, color: '#2563eb' }}>
  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
</svg>
);

const FileIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 48, height: 48, color: '#16a34a' }}>
  <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
  <polyline points="14 2 14 8 20 8" />
</svg>
);



const DatabaseIcon = () => (
<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 48, height: 48, color: '#f97316' }}>
  <ellipse cx="12" cy="5" rx="9" ry="3" />
  <path d="M3 5V19A9 3 0 0 0 21 19V5" />
  <path d="M3 12A9 3 0 0 0 21 12" />
</svg>
);



const Ecommerce = () => {
  const navigate = useNavigate();
  const useCases = [    
    {
      icon: <FileIcon />,
      title: "Integration Schema Automation  ",
      description: "Allow users to configure integrations by providing prompts, e.g., create integration for kibo order. ",
      details: [
        "Integration name.",
        "User prompt.",       
      ]
    },
    {
      icon: <DatabaseIcon />,
      title: "Intelligent Endpoint Management ",
      description: "Enable users to retrieve and manage data from stored files in a vector or knowledge base using secure authentication, predefined protocols, and structured APIs.  ",
      details: [
        "Base URL of the integration",
        "API token for authentication",
        "Endpoint name.",        
      ]
    },
   
    {
      icon: <DatabaseIcon />,
      title: "Auto-Generated Data Models ",
      description: "Generate a unified schema by analyzing user-provided source and target schemas, along with template definitions.",
      details: [
        "Source schema(s).",
        "Target schema(s).",
        "Template name.",
        "User Prompts"
      ]
    },
   
    
    
  ];

  return (
    <div className="wrapper">
      {<ServiceHeader title="AI-Powered E-Commerce Solutions" />}

       <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column', 
      backgroundColor: '#f9fafb' 
    }}>
      {/* Use Cases Section */}
      <section style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '4rem 1.5rem' 
      }}>
        <h2 style={{ 
          fontSize: '1.875rem', 
          fontWeight: 'bold', 
          textAlign: 'center', 
          marginBottom: '3rem' 
        }}>
          Our Comprehensive AI E-Commerce Solutions
        </h2>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(3, minmax(250px, 1fr))', 
          gap: '1.5rem' 
        }}>
          {useCases.map((useCase, index) => (
            <div 
              key={index} 
              style={{ 
                backgroundColor: 'white', 
                padding: '1.5rem', 
                borderRadius: '0.5rem', 
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)', 
                transition: 'all 0.3s',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-6px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                marginBottom: '1rem' 
              }}>
                {useCase.icon}
                <h3 style={{ 
                  marginLeft: '1rem', 
                  fontSize: '1.25rem', 
                  fontWeight: 600 
                }}>
                  {useCase.title}
                </h3>
              </div>
              <p style={{ 
                color: '#4b5563', 
                marginBottom: '1rem' 
              }}>
                {useCase.description}
              </p>
              
              <div style={{ marginTop: '1rem' }}>
                {useCase.details.map((detail, detailIndex) => (
                  <div 
                    key={detailIndex} 
                    style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      marginBottom: '0.5rem' 
                    }}
                  >
                    <span style={{ 
                      color: '#10b981', 
                      marginRight: '0.5rem' 
                    }}>
                      ✓
                    </span>
                    <span>{detail}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    
      
<section
  style={{
    maxWidth: '1200px',
    margin: '3rem auto',
    padding: '0 1.5rem',
  }}
>
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(280px, 1fr))',
      gap: '10rem',
    }}
  >
    <div
      style={{
        backgroundColor: 'white',
        padding: '1.5rem',
        borderRadius: '0.5rem',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none"
          viewBox="0 0 24 24" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 3v18l15-9L5 3z" />
        </svg>
        <h3 style={{ marginLeft: '1rem', fontSize: '1.25rem', fontWeight: 600 }}>cQube Ecommerce App</h3>
      </div>
      <p style={{ color: '#4b5563', marginBottom: '1rem' }}>
        Access our cQube ecommerce AI platform.
      </p>
      <button
        // onClick={() => window.open("https://utility.sstglobal.net/", "_blank")}
        onClick={() => {
          const baseUrl = window.location.origin;
          window.open(`${baseUrl}/login`, "_blank");
        }}
        style={{
          backgroundColor: '#2563eb',
          color: 'white',
          padding: '0.5rem 1.5rem',
          borderRadius: '0.375rem',
          fontWeight: '600',
          fontSize: '0.95rem',
          border: 'none',
          cursor: 'pointer',
          alignSelf: 'start'
        }}
      >
        Ecommerce Demo
      </button>
    </div>
    <div
      style={{
        backgroundColor: 'white',
        padding: '1.5rem',
        borderRadius: '0.5rem',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none"
          viewBox="0 0 24 24" stroke="#7c3aed" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <line x1="10" y1="9" x2="9" y2="9" />
        </svg>
        <h3 style={{ marginLeft: '1rem', fontSize: '1.25rem', fontWeight: 600 }}>Download Ecommerce Deck</h3>
      </div>
      <p style={{ color: '#4b5563', marginBottom: '1rem' }}>
        Access the PDF for complete overview of Ecommerce AI.
      </p>
      <a
        href="https://stlangutilitydev.blob.core.windows.net/uploadfiles/cQube-deck.pdf"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          backgroundColor: '#7c3aed',
          color: 'white',
          padding: '0.5rem 1.5rem',
          borderRadius: '0.375rem',
          fontWeight: '600',
          fontSize: '0.95rem',
          textDecoration: 'none',
          alignSelf: 'start'
        }}
      >
        Download PDF
      </a>
    </div>
  </div>
</section>
    </div>
    </div>
  );
};

export default Ecommerce;
